import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import {Button, Divider, Grid, IconButton, MenuItem, TextField, Typography} from "@mui/material";
import {useState} from "react";
import { Popover } from "./Popover";
import {useUser} from "./Permission";
import {clientDebug} from "./ClientDebug";
import {api} from "../api/API";
import {useAsync2} from "nate-react-api-helpers";
import {CheckCircle, FileCopy} from "@mui/icons-material";
import {green} from "@mui/material/colors";
import {ApiKeysDialog} from "./ApiKeys";
import {UserPreferencesDialog} from "./userpref/UserPreferencesDialog";

export function CurrentUser() {
    const usr = useUser();
    const [anchor, setAnchor] = useState<HTMLElement|null>(null);
    const [open, setOpen] = useState(false);
    const [showDiagnostic, setShowDiagnostic] = useState(false);
    const [showApiKeys, setShowApiKeys] = useState(false);
    const [showPreferences, setShowPreferences] = useState(false);

    if(!usr) return null;

    return (
        <>
            <IconButton size="small" style={{color: "white"}} ref={r => setAnchor(r)}
                        onClick={() => setOpen(true)}>
                <AccountCircleIcon />
            </IconButton>
            <Popover
                open={open} anchorEl={anchor} anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
                      transformOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                      }}
                      onClose={() => setOpen(false)}>
                <div style={{padding: 10, width: 250}}>
                    <Grid container spacing={2} wrap="nowrap">
                        <Grid item>
                            <div style={{fontSize: "1.5rem"}}>
                                <AccountCircleIcon color="inherit" fontSize="inherit" />
                            </div>
                        </Grid>
                        <Grid item>
                            <div>{usr.name}</div>
                            <div style={{fontSize: "0.75rem"}}>{usr.email}</div>
                        </Grid>
                    </Grid>
                </div>
                <Divider />
                <MenuItem onClick={() => {
                    setShowPreferences(true);
                    setOpen(false);
                }}>Preferences</MenuItem>
                <MenuItem onClick={() => {
                    setShowApiKeys(true);
                    setOpen(false);
                }}>API Keys</MenuItem>
                <MenuItem onClick={() => {
                    setShowDiagnostic(true);
                    setOpen(false);
                }}>Send Dianogistic Log</MenuItem>
                <Divider style={{marginTop: 0}} />
                <a style={{textDecoration: "none", color: "initial"}} href="/api/auth/logout"><MenuItem>Logout</MenuItem></a>
                <div style={{height: 8}} />
            </Popover>

            {showDiagnostic && <Popover open anchorEl={anchor}>
                <DiagnosticUploader onClose={() => {
                    setShowDiagnostic(false);
                }} />
            </Popover>}

            {showApiKeys && <ApiKeysDialog onClose={() => setShowApiKeys(false)} />}
            {showPreferences && <UserPreferencesDialog onClose={() => setShowPreferences(false)} />}
        </>
    )
}

export function DiagnosticUploader(props: {
    onClose(): void;
}) {

    const uploadDiagnostic = useAsync2(async () => {
        const f = clientDebug.makeTrace();
        return await api.debug.submit({
            file: f,
            browserUrl: window.location.toString(),
        });
    }, {}, []);

    return (
        <div style={{
            padding: 16,
            minWidth: 300,
        }}>
            <Typography variant="h6">Diagnostic Upload</Typography>
            {(uploadDiagnostic.loading || uploadDiagnostic.error) && uploadDiagnostic.LoadingElement}
            {uploadDiagnostic.result && <div>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 8,
                }}>
                    <div style={{color: green["800"], height: "1.3em"}}><CheckCircle /></div>
                    <Typography variant="body1">Succesful upload!</Typography>
                </div>
                <div style={{height: 12}} />
                Reference for technical support:
                <div style={{height: 4}} />
                <TextField value={uploadDiagnostic.result.customerId} fullWidth
                           InputProps={{
                               endAdornment: (
                                   // copy button
                                   <IconButton onClick={() => {
                                       navigator.clipboard.writeText(uploadDiagnostic.result?.customerId || "");
                                   }}><FileCopy /></IconButton>
                               )
                           }}
                />
            </div>}

            <div style={{height: 8}} />

            <div style={{
                display: "flex",
                justifyContent: "flex-end",
            }}>
                <Button onClick={() => props.onClose()}>Close</Button>
            </div>
        </div>
    )
}